import React from 'react';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('RichTextEditorInputFieldSkeleton', (theme) => ({
  root: {
    width: '100%',
    borderRadius: theme.radius.xs,
  },
  rounded: {
    borderRadius: theme.radius.md,
  },
}));

const RichTextEditorInputFieldSkeleton = ({
  height,
  rounded,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return <Skeleton className={classNames(classes.root, { [classes.rounded]: rounded })} variant="rect" height={height} {...dataAttrs('rich-text-editor-input-skeleton')} />;
};

RichTextEditorInputFieldSkeleton.defaultProps = {
  height: 90,
  rounded: true,
};

RichTextEditorInputFieldSkeleton.propTypes = {
  height: PropTypes.number,
  rounded: PropTypes.bool,
};

export { RichTextEditorInputFieldSkeleton };
